// extracted by mini-css-extract-plugin
export default {"tooltip":"QT-z","arrow":"RT-z"};